import React from 'react';
import Carousel from './Carousel';
import SalesContainer from './SalesContainer';
import StyledDelivery from './StyledDelivery';
import Brands from './brands';
import SubscribeSection from './subscription';
import Footer from './footer';
import '../styles/home.css'

function Home() {
  return (
    <>
<div
  id="home"
  className="bg-cover bg-center w-full min-h-[40vh] sm:min-h-[60vh] lg:min-h-[35vh] px-4 sm:px-6"
  style={{ backgroundImage: 'url(/images/dots.png)' }}
>
  <div className="flex flex-col justify-center items-center text-center h-full space-y-4 py-6">
    {/* Title */}
    <div className="div1a">
      <h1 className="text-lg sm:text-xl md:text-2xl lg:text-4xl font-bold">
        New Season Collection 2025
      </h1>
    </div>

    {/* Subtitle */}
    <div className="div1b">
      <h1 className="text-base sm:text-lg md:text-xl lg:text-2xl font-semibold leading-snug">
        Unleash Your Style: Where <br />
        <span className="text-currentnav">Fashion</span> Meets <span className="text-currentnav">Passion</span>
      </h1>
    </div>

    {/* Description (fixed) */}
    <div className="div1c max-w-md sm:max-w-xl md:max-w-2xl px-2">
      <p className="text-sm sm:text-base md:text-lg lg:text-xl leading-relaxed">
        Shop with the best where fashion makes sense.
        <span className=""><br /></span>
        Get unlimited access to different vendors.
      </p>
    </div>
  </div>
</div>


    <div>
        <Carousel />
        <SalesContainer />
        <StyledDelivery />
        <Brands />
        <SubscribeSection />
        <Footer />
      </div></>
  );
}

export default Home;
